
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { FIREARM_METADATA } from '../../firearm/model/firearm.metadata';
import { FirearmLifecycleStatus } from '../../firearm/model/firearm.types';
import { FIREARM_ASSIGNMENT_METADATA } from './firearm-assignment.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class FirearmAssignmentLogMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('FirearmAssignmentLog', {
      assetId: <PropertyMetadata> {
        name: 'assetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      assignments: <PropertyMetadata> {
        name: 'assignments',
        type: 'FirearmAssignment',
        plural: true,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: true,
        relationshipType: RelationshipType.OneToMany,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_ASSIGNMENT_METADATA;
        },
        byReference: true,
        unique: false
      },
      firearm: <PropertyMetadata> {
        name: 'firearm',
        type: 'Firearm',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_METADATA;
        },
        byReference: true,
        unique: false
      },
      acquireAssignmentId: <PropertyMetadata> {
        name: 'acquireAssignmentId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        relationship: false,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      currentAssignmentId: <PropertyMetadata> {
        name: 'currentAssignmentId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      currentlyAssignable: <PropertyMetadata> {
        name: 'currentlyAssignable',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      disposeAssignmentId: <PropertyMetadata> {
        name: 'disposeAssignmentId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      lifecycleState: <PropertyMetadata> {
        name: 'lifecycleState',
        type: 'FirearmLifecycleStatus',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      pendingActions: <PropertyMetadata> {
        name: 'pendingActions',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      pendingActionsCount: <PropertyMetadata> {
        name: 'pendingActionsCount',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      poolFirearm: <PropertyMetadata> {
        name: 'poolFirearm',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.assetId;
    return nullIfContainsNull(result);
  }
}



